import React, {useState} from 'react';
import { Toolbar, Grid, Stack, MenuItem, Button, IconButton, Paper, InputAdornment } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import { Link, useNavigate } from "react-router-dom"
import { useFormik } from 'formik';
import get from "lodash/get";
import CloseIcon from '@mui/icons-material/Close';
import SaveAltIcon from '@mui/icons-material/SaveAlt'; 
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "react-json-to-excel";
import AddIcon from '@mui/icons-material/Add';
import Alert from "../../../components/form/Alert";
import { useCanView } from "../../../config/hook/UserPermissions";

import InputText from "../../../components/form/InputText";

const ToolbarComponent = ({ setFilter, __, reload, isLoading }) => {
    const fuel = useSelector(state => state.masters.fuel);
    const canView = useCanView();
    const navigate = useNavigate();
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const onSubmit = (values) => {
        let Filters = "";

        if (!!values.name) { Filters = `name@=${values.name}` }
        switch (get(values, "isActive")) {
            case 1: { Filters = `${!!Filters ? `${Filters},` : ""}isActive==true` }; break;
            case 2: { Filters = `${!!Filters ? `${Filters},` : ""}isActive==false` }; break;
            default: break;
        }

        setFilter(Filters)
    }

    const isActive = [
        {
            value: 0,
            name: __(`isActive.all`),
        },
        {
            value: 1,
            name: __(`isActive.true`),
        },
        {
            value: 2,
            name: __(`isActive.false`),
        },
    ]

    const formik = useFormik({
        initialValues: {
            name: "",
            isActive: get(isActive, "[0].value"),
        },
        onSubmit,
    });

    const onClear = (field) => async () => {
        await formik.setFieldValue(field, "")
        formik.submitForm()
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-start", md: "flex-end" }}>
                    <Grid item xs={12} md={4} lg={3} xl={2}> 
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button className='w-[100px] min-w-[100px]' startIcon={<AddIcon/>} variant="contained" color="secondary" onClick={() => {
                                if (canView("MAESTROS/COMBUSTIBLES", "add")) {
                                    navigate("new");
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para agregar nuevos combustibles.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>{__(`toolbar.btn`)}</Button>
                        </Stack>
                    </Grid>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <Button
                            variant="contained"
                            color="success" // El color verde para el botón
                            startIcon={<SaveAltIcon />} // Icono de exportar
                            onClick={() =>  exportToExcel(fuel.data.data, 'Combustible')}
                            disabled={!fuel?.data.data || fuel.data.data.length === 0}
                        >
                            Exportar
                        </Button>
                        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
                    </Grid>
                </Grid>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent